module.exports = __webpack_public_path__ + "static/media/fly0228.407593c8.webp";